"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skippable = (value, fieldName, config) => {
    if (fieldName === '::tip::') {
        return false;
    }
    if (config.existyStrict) {
        return value === undefined;
    }
    if (typeof (value) === 'string') {
        return value.trim().length === 0;
    }
    return value === null || value === undefined;
};
